import React from 'react';
import { Skeleton } from 'antd';

export default function EpisodeSkeleton() {
    return (
        <div style={{ padding: '0 2em' }}>
            <Skeleton avatar={{shape: 'square', size: 'large'}} active title={false} paragraph={{ rows: 3 }} />
        </div>
    )
}
